(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__gorillaListClickBridge) return;
  window.__gorillaListClickBridge = true;
  let last = { card: null, time: 0 };
  function track(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    const card = link && link.closest('[data-gb-list-product]');
    if (!card || !link.pathname.includes('/products/')) return;
    const now = Date.now();
    if (last.card === card && now - last.time < 500) return;
    try {
      const item = JSON.parse(card.dataset.gbListProduct);
      const api = window.Shopify && window.Shopify.analytics;
      if (!item.item_id || !api || typeof api.publish !== 'function') return;
      const list = card.closest('#product-grid, .product-grid, slider-component, product-recommendations') || card.parentElement;
      const section = card.closest('.shopify-section');
      const heading = section && section.querySelector('h2');
      const name = card.dataset.gbListName || (heading && heading.textContent.trim()) || 'Product recommendations';
      item.index = Math.max(0, Array.from(list.querySelectorAll('[data-gb-list-product]')).indexOf(card));
      item.item_list_name = name;
      last = { card, time: now };
      Promise.resolve(api.publish('gorilla_product_list_clicked', {item_list_name: name, items: [item]})).catch(() => {});
    } catch (_) {}
  }
  document.addEventListener('click', track, true);
  document.addEventListener('auxclick', track, true);
})();
  } catch(e) { console.error(e); }
})();

})();
